import type { VideoStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { VideoPresentation } from './VideoPresentation';

export function VideoPresentationDataHandler() {
  const { useConfig, InteractiveCanvasComponents } = usePresentationContext();

  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as VideoStaticContent;

  const { readonly, mode } = useConfig();

  return (
    <VideoPresentation
      title={staticContent.caption}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      textSizeOffset={staticContent.textSizeOffset}
      isReadOnly={readonly}
      isScreenshotMode={mode === 'screenshot'}
      videoUrl={staticContent.url}
      CanvasTitleArea={InteractiveCanvasComponents?.CanvasTitleArea}
    />
  );
}
